import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";

export default function MonthlyReportDetails() {
    // =========>> Constant
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();
    const currentMonthYear = currentMonth.toString() + currentYear.toString();

    // ========================>> useState
    const [searchTerm, setSearchTerm] = useState('');
    const [dateSelectionView, setDateSelectionView] = useState({
        month: currentMonth,
        year: currentYear,
    });
    const [dateSelectionViewRecordLoading, setDateSelectionViewRecordLoading] = useState();
    
    const [listingDataLoading, setListingDataLoading] = useState(false); 
    const [listingData, setListingData] = useState([]);  
    const [idToDelete, setIdToDelete] = useState(null);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    const [dialogData, setDialogData] = useState({ title: "", action: "", id: null });
    const [showDialog, setShowDialog] = useState(false);  
    const [showErrorDialog, setShowErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [formData, setFormData] = useState({
        id: "",
        previous_water_usage: "",
        current_water_usage: "",
        water_usage_price: "",
        electricity_usage: "",
        garbage: "",
        late_penalty: "",
        vehicle_charge: "",
        room_price_calculating: "",
        total_debt_update: "",
    });
    // Alert message
    const [alertVisible, setAlertVisible] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertSeverity, setAlertSeverity] = useState('success');
    // =================>> Handle input changes
    const handleDateSelectionViewInputChange = (e) => {
        const { name, value } = e.target;
        setDateSelectionView((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => {
            const updatedFormData = { ...prevFormData, [name]: value };
    
            if (name === 'previous_water_usage' || name === 'current_water_usage') {
                const previousWaterUsage = parseFloat(updatedFormData.previous_water_usage) || 0;
                const currentWaterUsage = parseFloat(updatedFormData.current_water_usage) || 0;
                updatedFormData.water_usage_price = (currentWaterUsage - previousWaterUsage) * 2000;
            }
    
            return updatedFormData;
        });
    };


    let monthRender = [];
    for (let i = 1; i <=12; i++) {
        monthRender.push(i);
    }

    let yearRender = [];
    for (let i = currentYear; i >= 2024; i--) {
        yearRender.push(i);
    }
    // ========================================================>> Fetch API

    // ===========>> Fetch search
    const fetchSearch = async (searchTerm) => {
        const monthYear = dateSelectionView.month.toString() + dateSelectionView.year.toString();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/monthly-report/search?search=${searchTerm}&monthYear=${monthYear}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });
    
            if (!response.ok) {
                throw new Error('Failed to fetch search');
            }
    
            const data = await response.json(); 
            setListingData(data); 
        } catch (error) {
            console.error('Error fetching search:', error);
        }
    };
    const handleSearchSubmit = (event) => {
        event.preventDefault(); 
        fetchSearch(searchTerm); 
    }

    const handleViewRecord = async (event) => {
        event.preventDefault();
        setListingDataLoading(true);
        setListingData([]);
        const monthYear = dateSelectionView.month.toString() + dateSelectionView.year.toString();

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/monthly-report?monthYear=${monthYear}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch data.');
            }

            const dataExpense = await response.json();
            setListingData(dataExpense);
        } catch (err) {
            console.error(err.message);
        } finally {
            setListingDataLoading(false);
        }
    }

    const fetchView = async (currentMonthYear) => {
        setListingDataLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/monthly-report?monthYear=${currentMonthYear}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch data.');
            }

            const dataExpense = await response.json();
            setListingData(dataExpense);
        } catch (err) {
            console.error(err.message);
        } finally {
            setListingDataLoading(false);
        }
    };

    useEffect(() => {
    }, [listingData]); 

    useEffect(() => {

        const currentMonthYear = currentMonth.toString() + currentYear.toString();
        setDateSelectionView({
            month: currentMonth,
            year: currentYear
        })
        fetchView(currentMonthYear);  
    }, []);

    const renderActionButton = (id) => {
        return (
            <div className="render-action-buttons flex justify-center">
                <button onClick={() => {handleEditListing(id)}} className="flex bg-blue-700 rounded-xl py-1 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center mr-3">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4 mr-1">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                    </svg>
                    <span className="hidden lg:flex">Edit</span>
                </button>
                <button onClick={() => {handleDeleteListing(id)}} className="flex bg-red-700 rounded-xl py-1 pl-2 pr-1 lg:px-3 text-white text-sm justify-center items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-4 mr-1">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                    </svg>
                    <span className="hidden lg:flex">Delete</span>
                </button>
            </div>
        )
    }

    const handleEditListing = (data) => {
        setFormData({
            id: data.id,
            previous_water_usage: Number(data.previous_water_usage),
            current_water_usage: Number(data.current_water_usage),
            water_usage_price: Number(data.water_usage_price),
            electricity_usage: (Number(data.electricity_usage) > 0) ? Number(data.electricity_usage) - 1000 : 0,
            garbage: Number(data.garbage),
            late_penalty: Number(data.late_penalty),
            vehicle_charge: Number(data.vehicle_charge),
            room_price_calculating: Number(data.room_price_calculating),
            total_debt_update: Number(data.total_debt),
        });
        setDialogData({ title: "កែប្រែទិន្នន័យ", action: "edit", data });
        setShowDialog(true);
    }

    const handleDeleteListing = (idToDelete) => {
        setIdToDelete(idToDelete.id);
        setDeleteDialogOpen(true); // Open the confirmation dialog
    };

    const confirmDelete = async () => {
        setDeleteDialogOpen(false); // Close the dialog
        if (!idToDelete) return;

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/monthly-report/${idToDelete}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error("ទិន្នន័យបរាជ័យក្នុងការលុប"); // Handle non-2xx responses
            }

            // Show success alert
            setAlertMessage("ទិន្នន័យត្រូវបានលុបដោយជោគជ័យ");
            setAlertSeverity("success");
            setAlertVisible(true);

            setTimeout(() => {
                setAlertVisible(false);
            }, 1000);
            fetchView();
        } catch (error) {
            console.error(error.message);
            setAlertMessage(error.message);
            setAlertSeverity("error");
            setAlertVisible(true);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (formData.previous_water_usage.length === 0) {
            setErrorMessage("សូមបញ្ចូលទឹកខែចាស់");
            setShowErrorDialog(true);
            return;
        }

        if (formData.current_water_usage.length === 0) {
            setErrorMessage("សូមបញ្ចូលទឹកខែថ្មី");
            setShowErrorDialog(true);
            return;
        }

        if (formData.electricity_usage.length === 0) {
            setErrorMessage("សូមបញ្ចូលតម្លៃភ្លើង");
            setShowErrorDialog(true);
            return;
        }

        if (formData.late_penalty.length === 0) {
            setErrorMessage("សូមបញ្ចូលថ្លៃពិន័យ");
            setShowErrorDialog(true);
            return;
        }

        if (formData.vehicle_charge.length === 0) {
            setErrorMessage("សូមបញ្ចូលថ្លៃផ្ញើរយានជំនិះ");
            setShowErrorDialog(true);
            return;
        }

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/monthly-report/${formData.id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
        .then((response) => {
            if (!response.ok) {
                return response.json().then((data) => {
                    setAlertMessage(data.message);
                    setAlertSeverity("error");
                    setAlertVisible(true);
                    setTimeout(() => {
                        setAlertVisible(false);
                    }, 2000);
                    throw data;
                })
            }
            return response.json();
        })
        .then(() => {
            setShowDialog(false);
            setAlertMessage(`ទិន្នន័យត្រូវបានធ្វើបច្ចុប្បន្នភាពដោយជោគជ័យ`);
            setAlertSeverity("success");    
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000);
            const currentMonthYear = dateSelectionView.month.toString() + dateSelectionView.year.toString();
            fetchView(currentMonthYear);
        })
        .catch((error) => {
            setAlertMessage(error.message);
            setAlertMessage(`ទិន្នន័យត្រូវបានធ្វើបច្ចុប្បន្នភាពបរាជ័យ`);
            setAlertSeverity("error");
            setAlertVisible(true);
            setTimeout(() => {
                setAlertVisible(false);
            }, 2000)
        })
    };
    
    return (
        <div className="w-full h-[100dvh] bg-white flex flex-col">
            {/* Header */}
            <div className="w-full h-[8dvh] bg-[#0077B6] flex  items-center">
                <div className="md:w-[8%] pl-3 md:pl-10 items-center flex text-customWhite">
                    <NavLink to='/monthly-report'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12 text-white">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </NavLink>
                </div>
                <div className="w-[84%] flex justify-center">
                    <h2 className="text-2xl font-semibold text-customWhite">បញ្ជីប្រចាំខែ</h2>
                </div>
            </div>

            {/* Body */}
            {/* Action buttons */}
            <div className="pt-5">
                <div className="mb-7 flex w-full lg:px-10 flex-col items-center md:items-stretch md:flex-row">
                    <form onSubmit={handleSearchSubmit} className="w-[100%] md:w-[50%] flex justify-center md:justify-stretch">
                        <div className="search-box pt-5">
                            <FontAwesomeIcon icon={faSearch} className="search-icon" />
                            <input
                                type="text"
                                placeholder="Search"
                                className=""
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)} 
                            />
                        </div>
                    </form>
                    <div className="md:ml-auto w-[100%] md:w-[30%] flex mt-5 md:mt-0 justify-center">
                        <form className="flex w-[90%] md:w-[100%] items-center" onSubmit={handleViewRecord}>
                            <FormControl
                            fullWidth
                            margin="dense"
                            sx={{
                                '& .MuiInputLabel-root': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiSelect-select': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    boxShadow: '0 1px 2px 0 #D9D9D9, 0 1px 2px 0 #E0E0E0'
                                },
                                marginRight: '15px',
                            }}
                            >
                                <InputLabel>ខែ *</InputLabel>
                                <Select
                                    name="month"
                                    value={dateSelectionView.month || ""}
                                    onChange={handleDateSelectionViewInputChange}
                                    label="ខែ *"
                                >
                                    {
                                        monthRender.map((month, index) => {
                                            return (
                                                <MenuItem key={index} value={month} sx={{fontFamily: 'Kantumruy Pro'}}>
                                                    {month}
                                                </MenuItem>
                                            );
                                        })
                                    }
                                </Select>
                            </FormControl>
                            <FormControl
                            fullWidth
                            margin="dense"
                            sx={{
                                '& .MuiInputLabel-root': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiSelect-select': {
                                    fontFamily: 'Kantumruy Pro',
                                    fontSize: '16px'
                                },
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '10px',
                                    boxShadow: '0 1px 2px 0 #D9D9D9, 0 1px 2px 0 #E0E0E0'
                                },
                                marginRight: '15px',
                            }}
                            >
                                <InputLabel>ឆ្នាំ *</InputLabel>
                                <Select
                                    name="year"
                                    value={dateSelectionView.year || ""}
                                    onChange={handleDateSelectionViewInputChange}
                                    label="ឆ្នាំ *"
                                >
                                    {
                                        yearRender.map((year, index) => {
                                            return (
                                                <MenuItem key={index} value={year} sx={{fontFamily: 'Kantumruy Pro'}}>
                                                    {year}
                                                </MenuItem>
                                            );
                                        })
                                    }
                                </Select>
                            </FormControl>
                                <button type="submit" className="h-14 bg-primary2 font-medium text-white px-6 ml-5 rounded-lg duration-200">
                                    {dateSelectionViewRecordLoading ? 'Loading...' : 'View'}
                                </button>
                        </form>
                        {/* <button className="bg-white border-2 hover:border px-10 py-1 sm:py-2 lg:py-2 rounded-3xl text-blue-700 flex text-xl sm:text-base lg:text-lg items-center mr-3 shadow-sm" onClick={togglePrint}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="blue" className="size-5 mr-1">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z" />
                            </svg> 
                            <span className="hidden lg:flex">ទាញយក</span>
                        </button> */}
                        {/* <button className="bg-secondary1 hover:shadow-md px-10 py-1 sm:py-2 items-center lg:py-2 rounded-3xl text-white flex text-xl sm:text-base lg:text-lg" onClick={toggleAdd}><span className="text-2xl">+</span> <span className="hidden sm:flex sm:ml-1">បន្ថែម</span><span className="hidden md:!flex lg:ml-0">ថ្មី</span></button> */}
                    </div>
                </div>

                {/* Table */}
                {listingDataLoading ? (
                    <div className="text-center my-10">
                        <p>Loading data...</p>
                    </div>
                    ) : (
                        <div className="overflow-x-auto overflow-y-auto !h-[76vh]">
                            <table className="table-display w-[100%]">
                                <thead className="!bg-secondary3 border-2">
                                    <tr>
                                        {/* <th className="rounded-tl-lg text-zinc-800  text-xs md:text-sm lg:!text-base">បន្ទប់</th> */}
                                        <th className="text-zinc-800  text-xs md:text-sm lg:!text-base !py-4 ml-3 text-center">បន្ទប់</th>
                                        <th className="text-zinc-800  text-xs md:text-sm lg:!text-base !py-4 text-right">ទឹកខែចាស់</th>
                                        <th className=" text-zinc-800  text-xs md:text-sm lg:!text-base !py-4 text-right">ទឹកខែថ្មី</th>
                                        <th className=" text-zinc-800  text-xs md:text-sm lg:!text-base !py-4 text-right">ចំនួនទឹក</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4 text-right">តម្លៃទឹក</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm lg:!text-base !py-4 text-right">តម្លៃភ្លើង</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4 text-right">យានជំនិះ</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm lg:!text-base !py-4 text-right">សំរាម</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4 text-right">សរុប</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4 text-right">ពិន័យ</th>
                                        <th className=" text-zinc-800 text-xs md:text-sm  lg:!text-base !py-4 text-right">បន្ទប់</th>
                                        {currentMonthYear == dateSelectionView.month.toString() + dateSelectionView.year.toString() && <th className="text-zinc-800 text-xs md:text-sm lg:!text-base !py-4 text-center">បំណុលសរុប</th>}
                                        <th className="text-zinc-800 text-xs md:text-sm lg:!text-base !py-4 text-center">កែសម្រួល</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listingData && listingData.reports ? (
                                        
                                        listingData.reports.map((listing, index) => (
                                            <tr key={index} className="even:bg-gray-100 hover:bg-gray-200">
                                                <td className=" text-xs md:text-sm lg:!text-base !py-4 ml-3 text-center">{listing.room.room_number || 'N/A'}</td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base text-right !py-4">
                                                    {listing.previous_water_usage !== undefined && listing.previous_water_usage !== null 
                                                        ? Math.round(Number(listing.previous_water_usage)).toLocaleString() 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4 text-right">
                                                    {listing.current_water_usage !== undefined && listing.current_water_usage !== null 
                                                        ? Math.round(Number(listing.current_water_usage)).toLocaleString() 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4 text-right">
                                                    {listing.water_usage_amount !== undefined && listing.water_usage_amount !== null 
                                                        ? Math.round(Number(listing.water_usage_amount)).toLocaleString() 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4 text-right">
                                                    {listing.water_usage_price !== undefined && listing.water_usage_price !== null 
                                                        ? Number(listing.water_usage_price).toLocaleString('en-US') + "៛" 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4 text-right">
                                                    {listing.electricity_usage !== undefined && listing.electricity_usage !== null 
                                                        ? Number(listing.electricity_usage).toLocaleString('en-US') + "៛" 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4 text-right">
                                                    {listing.vehicle_charge !== undefined && listing.vehicle_charge !== null 
                                                        ? Number(listing.vehicle_charge).toLocaleString('en-US') + "៛" 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4 text-right">
                                                    {listing.garbage !== undefined && listing.garbage !== null 
                                                        ? Number(listing.garbage).toLocaleString('en-US') + "៛"
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4 text-right">
                                                    {listing.total_amount !== undefined && listing.total_amount !== null 
                                                        ? Number(listing.total_amount).toLocaleString('en-US') + "៛"
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4 text-right">
                                                    {listing.late_penalty !== undefined && listing.late_penalty !== null 
                                                        ? Number(listing.late_penalty).toLocaleString('en-US') + "$" 
                                                        : '--'}
                                                </td>
                                                <td className="font-medium text-xs md:text-sm lg:!text-base !py-4 text-right">
                                                    {listing.room.price !== undefined && listing.room.price !== null 
                                                        ? Number(listing.room_price_calculating).toLocaleString('en-US') + "$" 
                                                        : '--'}
                                                </td>
                                                {currentMonthYear == dateSelectionView.month.toString() + dateSelectionView.year.toString() && <td className="font-medium text-xs md:text-sm lg:!text-base !py-4 text-right">
                                                    {listing.room.price !== undefined && listing.room.price !== null 
                                                        ? Number(listing.total_debt).toLocaleString('en-US') + "$" 
                                                        : '--'}
                                                </td>}
                                                <td className="w-[15%]">{renderActionButton(listing)}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="7">No records found for the selected month and year.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {
                                listingData && listingData.total ? (
                                    <div className="fixed bottom-0 left-0 right-0 bg-gray-100 shadow-md border-t border-gray-300 flex overflow-y-auto">
                                        <div className="flex-2 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            សរុប
                                        </div>
                                        <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            
                                        </div>
                                        <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            
                                        </div>
                                        <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            {Number(listingData.total.total_water).toLocaleString('en-US')}
                                        </div>
                                        <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            {Number(listingData.total.total_water_price).toLocaleString('en-US')}៛
                                        </div>
                                        <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            {Number(listingData.total.total_electricity).toLocaleString('en-US')}៛
                                        </div>
                                        <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            {Number(listingData.total.total_vehicle).toLocaleString('en-US')}៛
                                        </div>
                                        <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            {Number(listingData.total.total_garbage).toLocaleString('en-US')}៛
                                        </div>
                                        <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            {Number(listingData.total.total_amount).toLocaleString('en-US')}៛
                                        </div>
                                        <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            {Number(listingData.total.total_penalty).toLocaleString('en-US')}$
                                        </div>
                                        <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            {Number(listingData.total.total_room_price_calculating).toLocaleString('en-US')}$
                                        </div>
                                        {currentMonthYear == dateSelectionView.month.toString() + dateSelectionView.year.toString() && <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            {Number(listingData.total.total_total_debt).toLocaleString('en-US')}$
                                        </div>}
                                        <div className="flex-1 border-gray-300 px-4 py-2 text-center font-semibold">
                                            
                                        </div>
                                        <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                            
                                        </div>
                                    </div>
                                ) : (
                                    <div className="flex-1 border-r border-gray-300 px-4 py-2 text-center font-semibold">
                                        --
                                    </div>
                                )
                            }
                        </div>
                        
                    )
                }
                {alertVisible && (
                    <Stack sx={{ width: '100%', justifyContent: "flex-end", position: "fixed",
                        alignItems: "flex-end"}}  mt={-5} spacing={2} borderRadius={2}>
                        <Alert severity={alertSeverity} sx={{fontWeight: 500, fontSize: '16px'}}>
                            {alertMessage}
                        </Alert>
                    </Stack>
                )}          
            </div>
            
            {/* Dialog for Add/Edit */}
            <Dialog open={showDialog} onClose={() => setShowDialog(false)} sx={{
                '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                    fontFamily: 'Kantumruy Pro, sans-serif'
                }
            }}>
                <DialogTitle>{dialogData.title}</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit}>
                        <div className="flex space-x-4">
                            <TextField
                            margin="dense"
                            label="ទឹកខែចាស់ *"
                            name="previous_water_usage"
                            value={formData.previous_water_usage !== null ? formData.previous_water_usage : ''}
                            onChange={handleInputChange}
                            fullWidth
                            InputLabelProps={{
                                style: { fontFamily: 'Kantumruy Pro' },
                            }}
                            InputProps={{
                                style: {
                                    borderRadius: "8px",
                                    fontFamily: 'Kantumruy Pro',
                                }
                            }}
                            />
                            <TextField
                                margin="dense"
                                label="ទឹកខែថ្មី *"
                                name="current_water_usage"
                                value={formData.current_water_usage !== null ? formData.current_water_usage : ''}
                                onChange={handleInputChange}
                                fullWidth
                                InputLabelProps={{
                                    style: { fontFamily: 'Kantumruy Pro' },
                                }}
                                InputProps={{
                                    style: {
                                    borderRadius: "8px",
                                    fontFamily: 'Kantumruy Pro',
                                    }
                                }}
                            />
                        </div>
                        <div className="flex space-x-4">
                            <TextField
                                margin="dense"
                                label="ថ្លៃទឹក *"
                                name="water_usage_price"
                                value={formData.water_usage_price !== null ? formData.water_usage_price : ''}
                                onChange={handleInputChange}
                                fullWidth
                                InputLabelProps={{
                                    style: { fontFamily: 'Kantumruy Pro' },
                                }}
                                InputProps={{
                                    style: {
                                    borderRadius: "8px",
                                    fontFamily: 'Kantumruy Pro',
                                    }
                                }}
                            />
                            <TextField
                                margin="dense"
                                label="តម្លៃភ្លើង *"
                                name="electricity_usage"
                                value={formData.electricity_usage !== null ? formData.electricity_usage : ''}
                                onChange={handleInputChange}
                                fullWidth
                                InputLabelProps={{
                                    style: { fontFamily: 'Kantumruy Pro' },
                                }}
                                InputProps={{
                                    style: {
                                    borderRadius: "8px",
                                    fontFamily: 'Kantumruy Pro',
                                    }
                                }}
                            /> {Number(formData.electricity_usage) !== 0 ? <p className={`w-[20%] ${Number(formData.electricity_usage) !== 0 ? "ml-5" : "ml-0"}`}> + 1000</p> : <p></p>}
                        </div>
                        <TextField
                            margin="dense"
                            label="ថ្លៃសំរាម *"
                            name="garbage"
                            value={formData.garbage !== null ? formData.garbage : ''}
                            onChange={handleInputChange}
                            fullWidth
                            InputLabelProps={{
                                style: { fontFamily: 'Kantumruy Pro' },
                            }}
                            InputProps={{
                                style: {
                                borderRadius: "8px",
                                fontFamily: 'Kantumruy Pro',
                                }
                            }}
                        />
                        <TextField
                            margin="dense"
                            label="ថ្លៃផ្ញើរយានជំនិះ *"
                            name="vehicle_charge"
                            value={formData.vehicle_charge !== null ? formData.vehicle_charge : ''}
                            onChange={handleInputChange}
                            fullWidth
                            InputLabelProps={{
                                style: { fontFamily: 'Kantumruy Pro' },
                            }}
                            InputProps={{
                                style: {
                                borderRadius: "8px",
                                fontFamily: 'Kantumruy Pro',
                                }
                            }}
                        />
                        <TextField
                            margin="dense"
                            label="ថ្លៃពិន័យ *"
                            name="late_penalty"
                            value={formData.late_penalty !== null ? formData.late_penalty : ''}
                            onChange={handleInputChange}
                            fullWidth
                            InputLabelProps={{
                                style: { fontFamily: 'Kantumruy Pro' },
                            }}
                            InputProps={{
                                style: {
                                borderRadius: "8px",
                                fontFamily: 'Kantumruy Pro',
                                }
                            }}
                        />
                        <TextField
                            margin="dense"
                            label="ថ្លៃបន្ទប់ *"
                            name="room_price_calculating"
                            value={formData.room_price_calculating !== null ? formData.room_price_calculating : ''}
                            onChange={handleInputChange}
                            fullWidth
                            InputLabelProps={{
                                style: { fontFamily: 'Kantumruy Pro' },
                            }}
                            InputProps={{
                                style: {
                                borderRadius: "8px",
                                fontFamily: 'Kantumruy Pro',
                                }
                            }}
                        />
                        {currentMonthYear == dateSelectionView.month.toString() + dateSelectionView.year.toString() &&
                            <TextField
                                margin="dense"
                                label="បំណុលសរុប *"
                                name="total_debt_update"
                                value={formData.total_debt_update !== null ? formData.total_debt_update : ''}
                                onChange={handleInputChange}
                                fullWidth
                                InputLabelProps={{
                                    style: { fontFamily: 'Kantumruy Pro' },
                                }}
                                InputProps={{
                                    style: {
                                    borderRadius: "8px",
                                    fontFamily: 'Kantumruy Pro',
                                    }
                                }}
                            />
                        }
                    </form>
                </DialogContent>
                <DialogActions sx={{marginBottom: "16px"}}>
                <Button onClick={() => setShowDialog(false)} color="black"  
                sx={{paddingY: "8px", paddingX: "32px", marginRight: "16px",'&:hover': {
                    backgroundColor: '#f9f9f9',
                }, }}>
                    Cancel
                </Button>
                <Button onClick={handleSubmit} sx={{background: "#00B4D8", color: "white", paddingY: "8px", paddingX: "32px", marginRight: "16px" }}>
                    Save
                </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showErrorDialog} onClose={() => setShowErrorDialog(false)} sx={{
                '& .MuiDialogTitle-root, & .MuiDialogContent-root, & .MuiDialogActions-root': {
                    fontFamily: 'Kantumruy Pro, sans-serif',
                }
            }}>
                <DialogTitle sx={{color: "red"}}>Error</DialogTitle>
                <DialogContent>
                    <div style={{ whiteSpace: 'pre-line' }}>
                        {errorMessage}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowErrorDialog(false)} color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
                <DialogTitle sx={{ fontFamily: 'Kantumruy Pro'}}>បញ្ជាក់ការលុបបន្ទប់</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ fontFamily: 'Kantumruy Pro'}}>
                        តើអ្នកពិតជាចង់់លុបបន្ទប់នេះមែនទេ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={confirmDelete} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}